import {
  Button,
  Heading,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  useDisclosure,
} from "@chakra-ui/react";
import { ReactElement, useState } from "react";
import { useTranslation } from "react-i18next";
import { ServiceHour } from "../../api/types";
import useFetchServiceHours from "./hooks/useFetchServiceHours";
import SettingsServiceHoursModal from "./settings-service-hours-modal";

const SettingsServiceHours = (): ReactElement => {
  const { t } = useTranslation();
  const { serviceHours, refetchServiceHours } = useFetchServiceHours();
  const [selectedServiceHour, setSelectedServiceHour] = useState<ServiceHour | undefined>(undefined);

  const {
    isOpen: isServiceHoursModalOpen,
    onOpen: onServiceHoursModalOpen,
    onClose: onServiceHoursModalClose,
  } = useDisclosure();

  const openModal = (serviceHour?: ServiceHour) => {
    if (serviceHour) {
      setSelectedServiceHour(serviceHour);
    }
    onServiceHoursModalOpen();
  };

  const onModalClose = () => {
    setSelectedServiceHour(undefined);
    refetchServiceHours();
    onServiceHoursModalClose();
  };

  return (
    <>
      <Heading size="lg" mb={4}>
        {t("settings.service_hours.title")}
      </Heading>

      <TableContainer>
        <Table size="sm">
          <Thead>
            <Tr>
              <Th>{t("settings.service_hours.name")}</Th>
              <Th> </Th>
            </Tr>
          </Thead>
          <Tbody>
            {serviceHours.map(serviceHour => (
              <Tr key={serviceHour.id}>
                <Td pb={1} pt={1}>{serviceHour.name}</Td>
                <Td pb={1} pt={1}>
                  <Button colorScheme="blue" size="xs" onClick={() => openModal(serviceHour)}>
                    {t("settings.service_hours.edit")}
                  </Button>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </TableContainer>

      <Button mt={4} colorScheme="blue" onClick={() => openModal()}>
        {t("settings.service_hours.add_service_hour")}
      </Button>

      <SettingsServiceHoursModal
        isOpen={isServiceHoursModalOpen}
        onClose={onModalClose}
        serviceHour={selectedServiceHour}
      />
    </>
  );
};

export default SettingsServiceHours;
